__turbopack_context__.v({
  "qtySelector": "SidebarSuggestedSet-module-scss-module__Lfo33a__qtySelector",
  "root": "SidebarSuggestedSet-module-scss-module__Lfo33a__root",
  "sidebar-container": "SidebarSuggestedSet-module-scss-module__Lfo33a__sidebar-container",
  "sidebar-container-inner": "SidebarSuggestedSet-module-scss-module__Lfo33a__sidebar-container-inner",
  "sidebar-container-inner-wrapper": "SidebarSuggestedSet-module-scss-module__Lfo33a__sidebar-container-inner-wrapper",
  "sidebar-main": "SidebarSuggestedSet-module-scss-module__Lfo33a__sidebar-main",
  "sidebar-overlay": "SidebarSuggestedSet-module-scss-module__Lfo33a__sidebar-overlay",
});
